import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonNextStep: React.FC<MprcButtonProps> = ({ text, title, color = "primary", variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonNextStep.text;
    const lTitle = title || theme.buttons.ButtonNextStep.title;

    return (
        <MprcButton
            {...rest}
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
        />
    );
};
